import { symbol } from "./symbol.js";
<ebay-icon ...input _name="avatar-signed-out" _size="" _type="icon" _themes=symbol/>